"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var create_validator_1 = require("../create-validator");
var messages_1 = require("../messages");
var regexes = {
    withIssueNumber: /^[A-Z]{2}[A-Z|9]{3}[0-9]{6}[A-Z]{1}[A-Z|9]{1}[A-Z0-9]{3}[0-9]{2}$/i,
    withoutIssueNumber: /^[A-Z]{2}[A-Z|9]{3}[0-9]{6}[A-Z]{1}[A-Z|9]{1}[A-Z0-9]{3}$/i,
    northernIreland: /^\d{8}$/
};
var defaultOptions = {
    allowNI: false,
    issueNumber: "optional"
};
function validateGB(value, options) {
    var withIssueNumber = regexes.withIssueNumber, withoutIssueNumber = regexes.withoutIssueNumber;
    switch (options.issueNumber) {
        case "required":
            return withIssueNumber.test(value);
        case "prohibited":
            return withoutIssueNumber.test(value);
        default:
            return withIssueNumber.test(value) || withoutIssueNumber.test(value);
    }
}
function validateNI(value) {
    return regexes.northernIreland.test(value);
}
function validate(value, options) {
    var isValidGBNumber = validateGB(value, options);
    if (!options.allowNI) {
        return isValidGBNumber;
    }
    return isValidGBNumber || validateNI(value);
}
function createWithOptions(options) {
    if (options === void 0) { options = defaultOptions; }
    return create_validator_1.createValidator(function (x) { return !x || validate(x, options); }, options.message || messages_1.DRIVING_LICENCE);
}
function createWithString(message) {
    return createWithOptions(__assign({}, defaultOptions, { message: message }));
}
function validUKDrivingLicence(messageOrOptions) {
    return typeof messageOrOptions === "string"
        ? createWithString(messageOrOptions)
        : createWithOptions(messageOrOptions);
}
exports.validUKDrivingLicence = validUKDrivingLicence;
